import { render, staticRenderFns } from "./vault-list.vue?vue&type=template&id=26662150"
import script from "./vault-list.vue?vue&type=script&lang=js"
export * from "./vault-list.vue?vue&type=script&lang=js"
import style0 from "./vault-list.vue?vue&type=style&index=0&id=26662150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports